var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.597168,
    width: 21.5833,
    height: 21.5833,
    rx: 10.7917,
    fill: "#1D4469",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3362 13.6325L13.9947 12.2938C13.5156 11.8157 12.7011 12.007 12.5095 12.6285C12.3657 13.0588 11.8866 13.2979 11.4554 13.2022C10.4972 12.9632 9.20363 11.7201 8.96408 10.7161C8.82035 10.2858 9.10781 9.80772 9.53901 9.66431C10.1618 9.47307 10.3535 8.6603 9.87438 8.1822L8.53289 6.84353C8.1496 6.50886 7.57468 6.50886 7.23931 6.84353L6.32901 7.75192C5.41871 8.70811 6.42483 11.242 8.67662 13.4891C10.9284 15.7361 13.4677 16.788 14.4259 15.8318L15.3362 14.9234C15.6716 14.5409 15.6716 13.9672 15.3362 13.6325Z",
    fill: "#1D4469"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/ContactIcon.7dfd52d2392b06371cad590149f863fd.svg";
export { ForwardRef as ReactComponent };